module.exports = __webpack_public_path__ + "img/5_pc.aa7cb616.gif";